import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  data: [{
    text: 'recommended packs'
  }, {
    text: 't20 packs'
  }],
  initialSelectedIndex: 0,
  minWidthForSingleTabRatio: 0,
  showDivider: true,
  showAsPills: false,
  disableScroll: false
}, getTestId('TabsWidgetContainer'));